var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CognitoUser, AuthenticationDetails, CognitoUserAttribute, } from 'amazon-cognito-identity-js';
import { LOGIN_RESPONSE_SUCCESS, LOGIN_RESPONSE_CHANGE_PASSWORD, LOGIN_RESPONSE_ERROR, LOGIN_RESPONSE_MFA_REQUIRED, REGISTRATION_SUCCESS, REGISTRATION_INVALID_USERNAME, REGISTRATION_USERNAME_EXISTS, REGISTRATION_INVALID_PASSWORD, REGISTRATION_INVALID_PHONE_NUMBER, REGISTRATION_FAILURE_GENERIC, } from './const';
var CognitoAuthenticator = /** @class */ (function () {
    function CognitoAuthenticator(userPool, user) {
        this.userPool = userPool;
        this.user = user;
    }
    CognitoAuthenticator.fromIdentity = function (userPool, identity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new CognitoAuthenticator(userPool, identity.credentials.user)];
            });
        });
    };
    CognitoAuthenticator.prototype.login = function (_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var user, authDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getUser(username)];
                    case 1:
                        user = _b.sent();
                        authDetails = new AuthenticationDetails({
                            Username: username,
                            Password: password,
                        });
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.authenticateUser(authDetails, {
                                    onSuccess: function (session) {
                                        return resolve({
                                            code: LOGIN_RESPONSE_SUCCESS,
                                            credentials: session,
                                            identity: username,
                                        });
                                    },
                                    onFailure: function (err) {
                                        reject({
                                            code: LOGIN_RESPONSE_ERROR,
                                            error: err.code,
                                        });
                                    },
                                    mfaRequired: function (mfaDetails) {
                                        resolve({ code: LOGIN_RESPONSE_MFA_REQUIRED });
                                    },
                                    newPasswordRequired: function (attribs, requiredAttribs) {
                                        resolve({
                                            code: LOGIN_RESPONSE_CHANGE_PASSWORD,
                                            attribs: attribs,
                                            requiredAttribs: requiredAttribs,
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.completeChangePassword = function (newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.completeNewPasswordChallenge(newPassword, {}, {
                                    onSuccess: function (session) {
                                        return resolve({
                                            code: LOGIN_RESPONSE_SUCCESS,
                                            credentials: session,
                                            identity: user.getUsername(),
                                        });
                                    },
                                    onFailure: function (_a) {
                                        var code = _a.code;
                                        return reject(code);
                                    },
                                    mfaRequired: function () { return resolve({ code: LOGIN_RESPONSE_MFA_REQUIRED }); },
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.register = function (userData) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var username, password, email, phone, locale, attributeList;
            return __generator(this, function (_a) {
                username = userData.username, password = userData.password, email = userData.email, phone = userData.phone, locale = userData.locale;
                attributeList = [
                    {
                        Name: 'email',
                        Value: email,
                    },
                    {
                        Name: 'phone_number',
                        Value: phone,
                    },
                ].map(function (attrib) { return new CognitoUserAttribute(attrib); });
                if (locale) {
                    attributeList.push(new CognitoUserAttribute({
                        Name: 'locale',
                        Value: locale,
                    }));
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.userPool.signUp(username, password, attributeList, [], function (err, result) {
                            if (err) {
                                reject(_this.mapRegistrationError(err));
                                return;
                            }
                            // If there is not error, there is a result.
                            result = result;
                            _this.user = result.user;
                            var response = { code: REGISTRATION_SUCCESS, user: result.user };
                            resolve(response);
                        });
                    })];
            });
        });
    };
    CognitoAuthenticator.prototype.resendRegistrationCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve) {
                                user.resendConfirmationCode(function (err) {
                                    if (err) {
                                        console.error(err);
                                    }
                                    resolve();
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.confirmRegistration = function (code, forUsername) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser(forUsername)];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.confirmRegistration(code, false, function (error, result) {
                                    if (error) {
                                        return reject(error);
                                    }
                                    return resolve(result);
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.validateMFAToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.sendMFACode(token, {
                                    onSuccess: function (session) {
                                        return resolve({
                                            code: LOGIN_RESPONSE_SUCCESS,
                                            credentials: session,
                                            identity: user.getUsername(),
                                        });
                                    },
                                    onFailure: function (err) {
                                        reject({
                                            code: LOGIN_RESPONSE_ERROR,
                                            error: err.code,
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.beginResetPassword = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser(username)];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.forgotPassword({
                                    onSuccess: resolve,
                                    onFailure: reject,
                                    inputVerificationCode: resolve,
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.completeResetPassword = function (validationCode, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.confirmPassword(validationCode, newPassword, {
                                    onSuccess: resolve,
                                    onFailure: reject,
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.userChangePassword = function (oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.changePassword(oldPassword, newPassword, function (err, data) {
                                    if (err) {
                                        return reject(err);
                                    }
                                    return resolve(data);
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.enableMFA = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.enableMFA(function (err, result) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    resolve(result);
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.disableMFA = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                user.disableMFA(function (err, result) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    resolve(result);
                                });
                            })];
                }
            });
        });
    };
    CognitoAuthenticator.prototype.mapRegistrationError = function (error) {
        if (error.code === 'InvalidParameterException') {
            if (error.message.indexOf('email') !== -1) {
                return { code: REGISTRATION_INVALID_USERNAME };
            }
            if (error.message.indexOf('password') !== -1) {
                return { code: REGISTRATION_INVALID_PASSWORD };
            }
            if (error.message.indexOf('phone number') !== -1) {
                return { code: REGISTRATION_INVALID_PHONE_NUMBER };
            }
        }
        if (error.code === 'UsernameExistsException') {
            return { code: REGISTRATION_USERNAME_EXISTS };
        }
        return { code: REGISTRATION_FAILURE_GENERIC };
    };
    CognitoAuthenticator.prototype.getUser = function (username) {
        if (username === void 0) { username = ''; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.user || username) {
                    this.user = new CognitoUser({
                        Username: username,
                        Pool: this.userPool,
                    });
                }
                return [2 /*return*/, this.user];
            });
        });
    };
    return CognitoAuthenticator;
}());
export default CognitoAuthenticator;
//# sourceMappingURL=authentication.js.map